export const LUX_AI_SUBSCRIPTION_LINK = `https://www.luxedo.com/products/luxstudio-only`
export const LUX_PLAY_SUBSCRIPTION_LINK = `https://www.luxedo.com/products/luxstudio-and-luxplay`
